import React from "react";

// "About Us" section — renders ONLY when the owner wrote an about text.
// Desktop uses an editorial two-column composition (heading rail + reading-
// width body) so it doesn't read as another identical generic card; mobile
// keeps the simple stacked card.
// NOTE: a future "Our Work" photo gallery section is planned to slot in
// directly AFTER this section (before Why Choose Us) — keep that in mind.
export const PublicBusinessAbout = ({ about, t }) => {
  const text = (about || "").trim();
  if (!text) return null;
  return (
    <section
      className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-10 lg:p-14 mb-5 lg:mb-8"
      data-testid="public-about-section"
    >
      <div className="lg:grid lg:grid-cols-[240px_1fr] lg:gap-14">
        <div>
          <span className="block w-10 h-1 rounded-full bg-green-700 mb-3" aria-hidden="true" />
          <h2 className="font-display text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 tracking-tight">
            {t("public.about.title")}
          </h2>
        </div>
        <p
          className="mt-3 lg:mt-0 max-w-3xl text-gray-600 lg:text-lg leading-relaxed whitespace-pre-line"
          data-testid="public-about-text"
        >
          {text}
        </p>
      </div>
    </section>
  );
};
